import {useNavigationState} from '@react-navigation/native';
import {useMemo} from 'react';

export const usePathname = () => {
  const navigationState = useNavigationState(state => state);

  return useMemo(() => window.location.pathname, [navigationState]);
};
